/**
 * @Auther: Qsan
 * @Date：2018年12月12日 16:31
 * @Desc：axios封装 请求拦截、相应拦截、错误统一处理
 */
import { Message } from "element-ui";
// import Cookies from 'js-cookie'
import router from "@/router";
import { getToken, removeToken } from "./auth";
import axios from "axios";
import qs from "qs";
import env from "./env";
import { validatenull } from "./validate";
import { filterParams, resetMessage } from "./utils";
import store from "../store";

// let reqCount = 0
// let loading

// let showLoading = function () {
//     if (reqCount === 0) {
//         loading = Loading.service({
//             lock: true,
//             text: '加载中……',
//             background: 'rgba(0, 0, 0, 0.7)'
//         })
//     }
//     reqCount++
// }

// let hideLoading = function () {
//     if (reqCount <= 0) return
//     reqCount--
//     if (reqCount === 0) {
//         loading.close()
//     }
// }
// let CancelToken = axios.CancelToken;
// let source = CancelToken.source();
// console.log(, "source");
// create an axios instance

let pending = []; // 声明一个数组用于存储每个请求的取消函数和axios标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  // console.log(config,config);
  for (let i in pending) {
    if (pending[i].url === axios.defaults.baseURL + config.url) {
      // 在当前请求在数组中存在时执行取消函数
      pending[i].f(); // 执行取消请求操作
      // pending.splice(i, 1); 根据具体情况决定是否在这里就把pending去掉
      // console.log(pending[i].url);
    }
  }
};

// 二次封装 ajax请求
let instance = axios.create({
  baseURL: env.baseUrl, // 请求基本地址
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'Content-Type':  isJson === 1 ? 'application/json' : 'application/x-www-form-urlencoded',
  },
  timeout: 20000, // 请求的超时时间
  withCredentials: true, // 允许携带cookie
  loading: false, // 是否显示loading
  showDefaultErrorMsg: true,
});
// instance.defaults.transformRequest = [
//     function (data) {
//         for (let it in data) {
//             if (data[it] == null || data[it] === undefined || data[it] === '') {
//                 delete data[it]
//             }
//         }
//         return JSON.stringify(data)
//     }
// ]

// http状态码拦截
axios.defaults.validateStatus = (status) => {
  console.log(status, "start-da");

  if (status === 403) {
    router.push({ name: "403" });
    return false;
  } else if (status === 500) {
    // router.push({ name: "500" });
    return false;
  } else if (status === 401) {
    // store.dispatch('LogOut').then(() => {
    Message.error("用户无权限请从新登录");
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--; ) {
        document.cookie = keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.kevis.com
        document.cookie = keys[i] + "=0;path=/;domain=" + document.domain + ";expires=" + new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.kevis.com
        document.cookie = keys[i] + "=0;path=/;domain=kevis.com;expires=" + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .kevis.com
      }
    }

    router.push({ path: "/account/login" });
    // }).catch(() => {
    // Message.error('该账号已在其他机器登录！')
    // router.push({ name: 'login' })
    // });
    return false;
  } else if (status === 404) {
    router.push({ name: "404" });
    return false;
  } else {
    return status >= 200 && status < 300;
  }
};

// http请求拦截
instance.interceptors.request.use(
  (config) => {
    if ((config.params && config.params.pageSize && config.url.indexOf("/order/page-with-detail") !== -1) || config.url.indexOf("/t-tenant-customer-feedback/getFeedBackList") !== -1) {
      removePending(config); // 在一个axios发送前执行一下判定操作，在removePending中执行取消操作
      // console.log(config.url);
      config.cancelToken = new cancelToken(function executor(c) {
        // 本次axios请求的配置添加cancelToken
        pending.push({
          // url: config.url,
          url: axios.defaults.baseURL + config.url,
          f: c,
        });
      });
    }

    // 判断网络状态
    if (!window.navigator.onLine) {
      resetMessage.error("无网络连接，请重新连接网络");
    }
    // get请求过滤出值为空字符串的参数
    if (config.method == "get") {
      config.params = filterParams(config.params);
    }
    // 判断token信息是否存在 如果存在进行拼接
    if (getToken()) {
      // eslint-disable-next-line no-undef
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config; // 返回配置完成的请求信息config
  },
  (err) => {
    // 打印错误
    //   Message.error({
    //     message: "加载超时"
    //   });
    console.log("request", err);
    return Promise.reject(err);
  }
);

// http 响应拦截

instance.interceptors.response.use(
  (data) => {
    store.commit("set_updateServerTime", JSON.parse(data.headers["x-date"]));
    window.localStorage.setItem("serverTime", data.headers["x-date"]);
    if (data.data.code === 500022) {
      removeToken();
      router.push({ path: "/account/login" });
      return Promise.reject(data);
    }
    removePending(data.config);
    if (data.data.code !== 0) {
      Message.error(`${!validatenull(data.data.msg) ? data.data.msg : data.data.message}`);
      return Promise.reject(data);
    }
    return Promise.resolve(data);
  },
  (err) => {
    let originalRequest = err.config;
    if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1 && !originalRequest._retry) {
      console.log("网络请求错误");
      return resetMessage.error("网络请求超时，请检查您的网络是否连接！");
    }
    if (JSON.parse(JSON.stringify(err)).response.data.status == 401) {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie = keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.kevis.com
          document.cookie = keys[i] + "=0;path=/;domain=" + document.domain + ";expires=" + new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.kevis.com
          document.cookie = keys[i] + "=0;path=/;domain=kevis.com;expires=" + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .kevis.com
        }
      }
      window.localStorage.clear();
      router.push({ path: "/account/login" });
    }

    // console.log(JSON.parse(JSON.stringify(err)));
    // console.log(JSON.parse(err));
    // Message.error({
    //     message: "系统错误!请及时联系管理员!"
    // });
    return Promise.reject(err);
  }
);

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, config) {
  if (config) {
    params = qs.stringify(params);
  }
  return new Promise((resolve, reject) => {
    instance
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params, config) {
  if (config) {
    params = qs.stringify(params);
  }
  return new Promise((resolve, reject) => {
    instance
      .put(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * del方法，对应del请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    instance
      .delete(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export default instance;



// WEBPACK FOOTER //
// ./src/common/http.js